var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"height":"100%","overflow":"hidden"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }